export default __webpack_public_path__ + "8c2f2960d459d5e2b07c10388b70957c.png";